<template>
  <div id="app">
    <div class="shadow-top"></div>
    <div class="shadow-top-right"></div>
    <div class="bottom-shadow">
      <img src="./assets/lines.png" class="shadow-bottom-left"/>
    </div>
    <div class="bottom-shadow-right">
      <img src="./assets/lines-1.png" class="shadow-bottom-right"/>
    </div>
    <transition
      :enter-active-class="slideType"
      mode="out-in"
      @beforeLeave="beforeLeave"
      @enter="enter"
      @afterEnter="afterEnter">
      <router-view :class="{'router-view': this.$route.name !== 'BecomeAnAgent'}" 
        :key="$route.params.slug" />
    </transition>
  </div>
</template>

<script>
const slideDown = ['Home', 'Blog', 'Projects', 'OurHouses', 'OurHousesDetails', 'Estates', 'About']
const slideUp = ['Contact', 'Privacy', 'Testimonials', 'BecomeAnAgent'] 
const bounceInDown = ['Home']
const bounceInUp = ['BecomeAnAgent']

export default {
  name: "App",
  metaInfo: {
    titleTemplate: '%s | RevolutionPlus | Real Estate ',
    htmlAttrs: {
      lang: 'en',
    },
    description: 'Revolution Plus Property Limited. The most trusted and reliable Real Estate Company in Nigeria. Buy Land in Ibeju Lekki. Buy Property at Sangotedo',
    keywords: 'Revolution Plus Property Limited.,Real Estate,Sangotedo,Eluju,Ibadan'
  },
  computed: {
    slideType() {
      const currentRouteName = this.$route.name
      let animationString = 'animate__animated animate__faster'
      if (slideDown.includes(currentRouteName)) {
        animationString = `${animationString} animate__slideInDown`
      }
      if (slideUp.includes(currentRouteName)) {
        animationString = `${animationString} animate__slideInUp`
      }
      if (bounceInDown.includes(currentRouteName)) {
        animationString = `${animationString} animate__bounceInDown`
      }
      if (bounceInUp.includes(currentRouteName)) {
        animationString = `${animationString} animate__bounceInUp`
      }
      return animationString
    }
  },
  methods: {
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = 'auto';
    },
  }
}
</script>

<style>
body, html {
  padding: 0;
  margin: 0;
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  background: #F9F9F9 0% 0% no-repeat padding-box !important;
}
#app {
  font-family:'Segoe UI Regular';
  font-weight:normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 0 50px;
  position: relative;
  overflow: hidden;
}
@media (max-width: 768px) {
  #app {
    padding: 0 10px;
  }
}
#nav {
  padding: 30px;
}
#nav a {
  font-family:'Segoe UI Bold';
  font-weight: normal;
  color: #2c3e50;
}
.font-bold, strong {
  font-family:'Segoe UI Bold';
  font-weight: normal;
}
.font-italics {
  font-family:'Segoe UI Italic';
}
#nav a.router-link-exact-active {
  color: #42b983;
}
.shadow-top {
  position: fixed;
  top: -70px;
  left: -100px;
  width: 400px;
  height: 400px;
  background: #6E2169 0% 0% no-repeat padding-box;
  opacity: 0.03;
  border-radius: 50%;
}
.shadow-top-right {
  position: fixed;
  top: -120px;
  right: -335px;
  width: 900px;
  height: 900px;
  background: #6E2169 0% 0% no-repeat padding-box;
  opacity: 0.03;
  border-radius: 50%;
  overflow: hidden;
}
.text-normal {
  color: #6E2169;
}
.text-black {
  color: #222;
}
.underlined {
  border-bottom: 2px solid #6E2169;
}
.bg-default-color {
  background-color: #6E2169;
  color: #fff !important;
}
.main-content {
  margin: 50px 0;
}
@media (max-width: 768px) {
  .main-content {
    margin: 25px 0;
  }
}
.btn-default-style {
  padding: 7px 5px;
  text-transform: uppercase;
  color: #222;
  border: 1px solid #6E2169;
  min-width: 200px;
  box-shadow: 5px 5px 6px #00000036;
  border-radius: 15px;
}
.btn-danger-custom {
  background-color: #FF0000;
  color: #fff;
  border: transparent;
}
.font-bold {
  font-weight: 700
}
.btn-normal {
  padding: 7px 5px;
  color: transparent;
  color: #6E2169;
  min-width: 140px;
  background-color: #fff;
  box-shadow: 10px 10px 6px #00000029;
  border-radius: 7px;
  border: transparent;
}
.text-md {
  font-size: 13px;
}
.bottom-shadow {
  position: absolute;
  bottom: 0;
  left: 0;
  overflow: hidden;
  width: 85%;
  height: 900px;
}
.shadow-bottom-left {
  position: absolute;
  bottom: -320px;
  left: -600px;
  width: 100%;
  height: 920px;
  opacity: 1;
}
.bottom-shadow-right {
  position: absolute;
  bottom: 0;
  right: 0;
  overflow: hidden;
  width: 85%;
  height: 900px;
}
.shadow-bottom-right {
  position: absolute;
  bottom: -320px;
  right: -600px;
  width: 100%;
  height: 920px;
  opacity: 1;
}
.no-underline {
  text-decoration: none!important;
}
.router-view {
  z-index: 100;
  position: relative;
}
</style>
